import { Link } from 'react-router-dom';
import styled from 'styled-components';

import Logo from './Logo';

function Header() {
    const logout = () => {
        const session_aid = window.sessionStorage.getItem('aid');
        const session_authCode = window.sessionStorage.getItem('authcode');

        fetch('https://api.kerbo.co.kr/auth?ai=' + session_aid + '&ac=' + session_authCode, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
        }).then((res) => {
            if (res.ok) {
                window.sessionStorage.removeItem('aid');
                window.sessionStorage.removeItem('authcode');
                window.location.reload();
            } else {
                alert('로그아웃 오류 발생');
            }
        });
    };

    return (
        <HeaderBox>
            <InnerWapper>
                <Link to="/">
                    <Logo />
                </Link>
                <Nav>
                    <a href="https://analytics.google.com/analytics/web/?hl=ko&pli=1#/p380105632/reports/reportinghub?params=_u..nav%3Dmaui" target="_blank" rel="noreferrer">
                        대시보드
                    </a>
                    <Link to="/list">글 목록</Link>
                </Nav>
            </InnerWapper>
            <LoginoutButton onClick={logout}>로그아웃</LoginoutButton>
        </HeaderBox>
    );
}

export default Header;

const HeaderBox = styled.header`
    position: sticky;
    top: 0;
    z-index: 100;

    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;

    width: 100%;
    min-width: 1355px;
    height: 165px;
    background-color: white;

    padding: 0px 160px;
    box-sizing: border-box;
`;

const InnerWapper = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    gap: 25px;

    margin-top: 30px;
`;

const Nav = styled.nav`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 18px;

    white-space: nowrap;

    font-size: 18px;
    color: #707070;
`;

const LoginoutButton = styled.button`
    height: fit-content;
    box-sizing: border-box;

    background-color: #343434;

    margin-top: 43px;
    padding: 10px 28px;

    border-radius: 20px;
    border: none;

    font-size: 18px;
    color: white;

    cursor: pointer;
`;
